module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [(_vm.isRequired) ? _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.controlLabel)
    }
  })]), _vm._v(" "), (_vm.controlType == 'plainText') ? _c('div', {
    staticClass: "col-sm-10",
    domProps: {
      "textContent": _vm._s(_vm.value)
    }
  }) : (_vm.controlType == 'lineText') ? _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.placeHolderText,
      "readonly": _vm.readonly,
      "id": _vm.controlID
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.valueUpdate($event.target.value)
      }
    }
  })]) : (_vm.controlType == 'number') ? _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.placeHolderText,
      "type": "number",
      "readonly": _vm.readonly,
      "id": _vm.controlID
    },
    domProps: {
      "value": _vm.value + ''
    },
    on: {
      "input": function($event) {
        _vm.valueUpdate($event.target.value)
      }
    }
  })]) : (_vm.controlType == 'yuan') ? _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.placeHolderText,
      "type": "number",
      "readonly": _vm.readonly,
      "id": _vm.controlID
    },
    domProps: {
      "value": _vm.value ? parseInt(_vm.value) / 100 : ''
    },
    on: {
      "input": function($event) {
        _vm.yuanUpdate($event.target.value)
      }
    }
  })]) : (_vm.controlType == 'digit') ? _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.placeHolderText,
      "type": "digit",
      "readonly": _vm.readonly,
      "id": _vm.controlID
    },
    domProps: {
      "value": _vm.value + ''
    },
    on: {
      "input": function($event) {
        _vm.valueUpdate($event.target.value)
      }
    }
  })]) : (_vm.controlType == 'multiLineText') ? _c('div', {
    staticClass: "col-sm-10"
  }, [_c('textarea', {
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.placeHolderText,
      "readonly": _vm.readonly,
      "id": _vm.controlID
    },
    domProps: {
      "value": _vm.value + ''
    },
    on: {
      "input": function($event) {
        _vm.valueUpdate($event.target.value)
      }
    }
  })]) : (_vm.controlType == 'richText') ? _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    attrs: {
      "id": 'toolbar' + _vm.inputId
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": _vm.inputId
    }
  })]) : (_vm.controlType == 'date') ? _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.placeHolderText,
      "type": "date",
      "readonly": _vm.readonly,
      "id": _vm.controlID
    },
    domProps: {
      "value": _vm.value + ''
    },
    on: {
      "input": function($event) {
        _vm.valueUpdate($event.target.value)
      }
    }
  })]) : (_vm.controlType == 'datetime') ? _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.placeHolderText,
      "type": "date",
      "step": "1",
      "readonly": _vm.readonly,
      "id": _vm.controlID
    },
    domProps: {
      "value": _vm.value.slice(0, 10)
    },
    on: {
      "input": function($event) {
        _vm.dateUpdate($event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.placeHolderText,
      "type": "time",
      "step": "1",
      "readonly": _vm.readonly,
      "id": _vm.controlID
    },
    domProps: {
      "value": _vm.value.slice(-8)
    },
    on: {
      "input": function($event) {
        _vm.timeUpdate($event.target.value)
      }
    }
  })])])]) : (_vm.controlType == 'checkbox') ? _c('div', {
    staticClass: "col-sm-10"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "checkbox",
      "disabled": _vm.readonly
    },
    domProps: {
      "checked": _vm.value
    },
    on: {
      "change": function($event) {
        _vm.checkboxChange($event.target.value)
      }
    }
  })])]) : (_vm.controlType == 'select') ? _c('div', {
    staticClass: "col-sm-10"
  }, [_c('select', {
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.placeHolderText,
      "disabled": _vm.readonly,
      "id": _vm.controlID
    },
    on: {
      "change": function($event) {
        _vm.selectChange($event.target.value)
      }
    }
  }, [(_vm.customItem) ? _c('option', {
    domProps: {
      "value": 0,
      "selected": _vm.value == 0,
      "textContent": _vm._s(_vm.customItem)
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.selectRange), function(item) {
    return _c('option', {
      key: item.id,
      domProps: {
        "value": item.id,
        "selected": item.id == _vm.value,
        "textContent": _vm._s(item.name)
      }
    })
  })], 2)]) : (_vm.controlType == 'regionSelect') ? _c('div', {
    staticClass: "col-sm-10"
  }, [(_vm.readonly) ? _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.value[0] + ',' + _vm.value[1] + ',' + _vm.value[2])
    }
  }) : [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('select', {
    staticClass: "form-control",
    domProps: {
      "value": _vm.value[0]
    },
    on: {
      "change": function($event) {
        _vm.provinceChange($event.target.value)
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "不限"
    }
  }, [_vm._v("不限")]), _vm._v(" "), _vm._l((_vm.provinceRange), function(item, index) {
    return _c('option', {
      key: index,
      attrs: {
        "id": _vm.controlID
      },
      domProps: {
        "value": item,
        "textContent": _vm._s(item)
      }
    })
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('select', {
    staticClass: "form-control",
    domProps: {
      "value": _vm.value[1]
    },
    on: {
      "change": function($event) {
        _vm.cityChange($event.target.value)
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "不限"
    }
  }, [_vm._v("不限")]), _vm._v(" "), _vm._l((_vm.cityRange), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item,
        "textContent": _vm._s(item)
      }
    })
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    staticClass: "form-control",
    domProps: {
      "value": _vm.value[2]
    },
    on: {
      "change": function($event) {
        _vm.regionChange($event.target.value)
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "不限"
    }
  }, [_vm._v("不限")]), _vm._v(" "), _vm._l((_vm.regionRange), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item,
        "textContent": _vm._s(item)
      }
    })
  })], 2)])])]], 2) : (_vm.controlType == 'image') ? _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    ref: "input",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": _vm.inputId,
      "type": "file",
      "accept": "image/gif,image/jpeg,image/jpg,image/png,image/svg"
    },
    on: {
      "change": _vm.handleSinglePicChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "picGrid"
  }, [(_vm.value) ? _c('div', {
    staticClass: "picGridItem"
  }, [_c('img', {
    staticClass: "picItem",
    attrs: {
      "src": _vm.value
    }
  }), _vm._v(" "), (!_vm.readonly) ? _c('img', {
    staticClass: "deleteBtn",
    attrs: {
      "src": "https://ogmcsrgk5.qnssl.com/vcdn/21841/小程序图标/删除.png"
    },
    on: {
      "click": _vm.clearPic
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.readonly && !_vm.value) ? _c('div', {
    staticClass: "picGridItem empty",
    on: {
      "click": _vm.addPic
    }
  }) : _vm._e()])]) : (_vm.controlType == 'multiImage') ? _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    ref: "input",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": _vm.inputId,
      "type": "file",
      "accept": "image/gif,image/jpeg,image/jpg,image/png,image/svg",
      "multiple": "multiple"
    },
    on: {
      "change": _vm.handleAlbumPicChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "picGrid"
  }, [_vm._l((_vm.value), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "picGridItem"
    }, [_c('img', {
      staticClass: "picItem",
      attrs: {
        "src": item
      }
    }), _vm._v(" "), (!_vm.readonly) ? _c('img', {
      staticClass: "deleteBtn",
      attrs: {
        "src": "https://ogmcsrgk5.qnssl.com/vcdn/21841/小程序图标/删除.png"
      },
      on: {
        "click": function($event) {
          _vm.delPic(index)
        }
      }
    }) : _vm._e()])
  }), _vm._v(" "), (!_vm.readonly && _vm.value.length < _vm.imageCntLimit) ? _c('div', {
    staticClass: "picGridItem empty",
    on: {
      "click": _vm.addPic
    }
  }) : _vm._e()], 2)]) : (_vm.controlType == 'multiSlide') ? _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "slideList"
  }, _vm._l((_vm.value), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "slideListItem"
    }, [(item.image) ? _c('img', {
      staticClass: "slideImageItem",
      attrs: {
        "src": item.image
      }
    }) : _c('input', {
      ref: "input",
      refInFor: true,
      staticClass: "form-control",
      attrs: {
        "type": "file",
        "accept": "image/gif,image/jpeg,image/jpg,image/png,image/svg"
      },
      on: {
        "change": function($event) {
          _vm.handleSlidePicChange(index)
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "slideLinkInputLabel",
      attrs: {
        "for": 'slide' + index
      }
    }, [_vm._v("链接")]), _vm._v(" "), _c('input', {
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "id": 'slide' + index
      },
      domProps: {
        "value": item.link
      },
      on: {
        "input": function($event) {
          _vm.handleSlideLinkChange(index, $event.target.value)
        }
      }
    }), _vm._v(" "), (!_vm.readonly) ? _c('img', {
      staticClass: "deleteBtn",
      attrs: {
        "src": "https://ogmcsrgk5.qnssl.com/vcdn/21841/小程序图标/删除.png"
      },
      on: {
        "click": function($event) {
          _vm.delSlide(index)
        }
      }
    }) : _vm._e()])
  })), _vm._v(" "), (!_vm.readonly) ? _c('div', {
    staticClass: "slideAddBtn",
    on: {
      "click": _vm.addSlide
    }
  }, [_vm._v(" ")]) : _vm._e()]) : (_vm.controlType == 'orderDetail') ? _c('div', {
    staticClass: "col-sm-10"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.value), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', {
      domProps: {
        "textContent": _vm._s(item.name)
      }
    }), _vm._v(" "), _c('td', {
      domProps: {
        "textContent": _vm._s(item.price / 100)
      }
    }), _vm._v(" "), _c('td', {
      domProps: {
        "textContent": _vm._s(item.count)
      }
    })])
  }))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("商品名称")]), _vm._v(" "), _c('th', [_vm._v("单价")]), _vm._v(" "), _c('th', [_vm._v("数量")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bab63d1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/FormControl.vue
// module id = 367
// module chunks = 1